import { render, staticRenderFns } from "./TransportRegular.vue?vue&type=template&id=57436a54"
import script from "./TransportRegular.vue?vue&type=script&lang=js"
export * from "./TransportRegular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports